import React from 'react'

const TermOfUse = () => {
  return (
    <div>
      term of use
    </div>
  )
}

export default TermOfUse
